import { UserOfflineComponent } from './user-offline.component';
import { CommonModule } from '@angular/common';
import { WordingModule } from '../../pipes';
import { MatButtonModule as MatButtonModule } from '@angular/material/button';
import { NgModule } from '@angular/core';

@NgModule({
  imports: [CommonModule, WordingModule, MatButtonModule, UserOfflineComponent],
  exports: [UserOfflineComponent],
})
export class UserOfflineModule {}
